// The OVERFLOW choice that sits under a <CellPicker/> grid — "in the room, not
// on the grid" (mig 20261021100001).
//
// Its own component, and deliberately BELOW the grid, because the grid stays
// the thing an operator reaches for first: this is the answer when the map has
// no answer, not a shortcut past reading it. The running count is on the face
// of it so a floor quietly drifting off its own map is visible at the moment of
// placement, rather than on next week's register.

import { Layers } from 'lucide-react'
import clsx from 'clsx'

export default function CellOverflowTile({ picked, count, onPick }: {
  picked: boolean
  /** How many pallets/bins are already standing in this room's overflow. */
  count:  number
  onPick: () => void
}) {
  return (
    <button
      type="button"
      onClick={onPick}
      aria-pressed={picked}
      className={clsx(
        'w-full text-left rounded-lg border px-3 min-h-[44px] py-2 transition-colors flex items-center gap-2.5',
        picked
          ? 'bg-amber-600 border-amber-400 text-white'
          : 'bg-amber-950/30 border-amber-800/60 text-amber-200 hover:bg-amber-900/40',
      )}>
      <Layers size={15} className="shrink-0" />
      <span className="flex-1 min-w-0">
        <span className="text-xs font-semibold block">Overflow — in the room, not on the grid</span>
        <span className={clsx('text-[10px] block', picked ? 'text-amber-100' : 'text-amber-300/80')}>
          {count > 0 ? `${count} already standing here` : 'For stock the grid has no cell for'}
        </span>
      </span>
    </button>
  )
}
